(function($) {
	formHelper.addRule({
		form: '.form-manage-special-pricing',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			},
			ERROR_MESSAGE_FOUR: function() {
				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage4);
				}
			},
			ERROR_MESSAGE_FIVE: function() {
				if(this.data.systemMessage5) {
					$('#system-message-5').html(this.data.systemMessage5);
				}
			}
		}
	});
})(jQuery);

jQuery(function initToolsManageSpecialPricing($) {
	$('.manage-special-pricing-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-special-pricing');

		// Date Restriction From Range
		// ------------------
		var $restrictionFromStart = $('#restriction-from-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromStartPicker = $restrictionFromStart.pickadate('picker');

		var $restrictionFromEnd = $('#restriction-from-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromEndPicker = $restrictionFromEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( restrictionFromStartPicker.get('value') ) {
			restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
		}
		
		if ( restrictionFromEndPicker.get('value') ) {
			restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
		}

		// When something is selected, update the "restrictionFromStart" and "restrictionFromEnd" limits.
		restrictionFromStartPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromEndPicker.set('min', false);
			}
		});

		restrictionFromEndPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromStartPicker.set('max', false);
			}
		});


		// Date Restriction To Range
		// ------------------
		var $restrictionToStart = $('#restriction-to-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionToStartPicker = $restrictionToStart.pickadate('picker');

		var $restrictionToEnd = $('#restriction-to-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionToEndPicker = $restrictionToEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( restrictionToStartPicker.get('value') ) {
			restrictionToEndPicker.set('min', restrictionToStartPicker.get('select'));
		}
		
		if ( restrictionToEndPicker.get('value') ) {
			restrictionToStartPicker.set('max', restrictionToEndPicker.get('select'));
		}

		// When something is selected, update the "restrictionToStart" and "restrictionToEnd" limits.
		restrictionToStartPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionToEndPicker.set('min', restrictionToStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionToEndPicker.set('min', false);
			}
		});

		restrictionToEndPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionToStartPicker.set('max', restrictionToEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionToStartPicker.set('max', false);
			}
		});		
	});
});

jQuery(function initToolsManageSpecialPricingAddForm($) {
	$('.add-special-pricing-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-add-special-pricing');

		// Date Restriction From Range
		// ------------------
		var $restrictionFromStart = $('#travel-restriction-date-from').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromStartPicker = $restrictionFromStart.pickadate('picker');

		var $restrictionFromEnd = $('#travel-restriction-date-to').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromEndPicker = $restrictionFromEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( restrictionFromStartPicker.get('value') ) {
			restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
		}
		
		if ( restrictionFromEndPicker.get('value') ) {
			restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
		}

		// When something is selected, update the "restrictionFromStart" and "restrictionFromEnd" limits.
		restrictionFromStartPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromEndPicker.set('min', false);
			}
		});

		restrictionFromEndPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromStartPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsManageSpecialPricingEditForm($) {
	$('.edit-special-pricing-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-special-pricing');		

		// Date Restriction From Range
		// ------------------
		var $restrictionFromStart = $('#travel-restriction-date-from').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromStartPicker = $restrictionFromStart.pickadate('picker');

		var $restrictionFromEnd = $('#travel-restriction-date-to').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromEndPicker = $restrictionFromEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( restrictionFromStartPicker.get('value') ) {
			restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
		}
		
		if ( restrictionFromEndPicker.get('value') ) {
			restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
		}

		// When something is selected, update the "restrictionFromStart" and "restrictionFromEnd" limits.
		restrictionFromStartPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromEndPicker.set('min', false);
			}
		});

		restrictionFromEndPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromStartPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsManageSpecialPricingResults($) {
	$('.manage-special-pricing-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-special-pricing-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});

jQuery(function initEditSpecialPricing($) {
	$('.edit-special-pricing-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-special-pricing');
		var $submitBtn             = $container.find('.btn-submit');
		var $copyBtn               = $container.find('.btn-copy');
		var $deleteBtn             = $container.find('.delete-button');

		$submitBtn.click(function() {
			$('#delete-special-pricing').val('no');
			$('#sp-status').val('edit');
		});

		$copyBtn.click(function() {
			$('#delete-special-pricing').val('no');
			$('#sp-status').val('copy');
			$form.submit();
		});

		$deleteBtn.click(function() {
			var r = confirm("Did you want to Continue?");
			if (r === true) {
			    $('#delete-special-pricing').val('yes');
				$form.submit();
			}
		});
	});
});

jQuery(function($){
	$('.js-special-pricing-actions').change(function() { 
		if($(this).val() !== '') {
			document.location.href = $(this).val(); 
		}
	})
});


jQuery(function($){
	$('#isRedemptionSale').change(function() { 
		
		if($("#isRedemptionSale").val() === "Y"){
			$("#special-pricing-value").attr("disabled", "disabled");
			$("#special-pricing-amount").attr("disabled", "disabled");
		}
		else{
			 $("#special-pricing-value").removeAttr("disabled");
			 $("#special-pricing-amount").removeAttr("disabled");
		}

	})
});